import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import axios from '@/services/axios';
export var FLOW_TYPE;
(function (FLOW_TYPE) {
  /**
   * activitySnackCash 激励现金（新）
   */
  FLOW_TYPE["activitySnackCash"] = "activitySnackCash";
  /**
   * activitySnackPoint 激励金币（新）
   */
  FLOW_TYPE["activitySnackPoint"] = "activitySnackPoint";
  /**
   * activitySnackPointMix ios激励现金（新）
   */
  FLOW_TYPE["activitySnackPointMix"] = "activitySnackPointMix";
  /**
     * activityCash 激励钱包现金（新）
     */
  FLOW_TYPE["activityCash"] = "activityCash";
  /**
   * activityPoint 激励金币流水（新）
   */
  FLOW_TYPE["activityPoint"] = "activityPoint";
  /**
   * activityPointMix 激励ios金币（新）
   */
  FLOW_TYPE["activityPointMix"] = "activityPointMix";
  /**
   * 钻石充值
   */
  FLOW_TYPE["liveDiamondRecharge"] = "liveDiamondRecharge";
  /**
   * 内容付费
   */
  FLOW_TYPE["commercialContent"] = "commercialContent";
  /**
   * 拍客
   */
  FLOW_TYPE["creatorPartner"] = "creatorPartner";
  /**
   * spotLight 本地
   */
  FLOW_TYPE["creatorSpotlightLocal"] = "creatorSpotlightLocal";
  /**
   * spotLight
   */
  FLOW_TYPE["creatorSpotlight"] = "creatorSpotlight";
  /**
   * 短视频赞赏
   */
  FLOW_TYPE["creatorDepositReward"] = "creatorDepositReward";
  /**
   * 创作者
   */
  FLOW_TYPE["creatorCash"] = "creatorCash";
  /**
   * kwai game
   */
  FLOW_TYPE["liveDiamondGaming"] = "liveDiamondGaming";
  /**
   * live game cash
   */
  FLOW_TYPE["liveGameCash"] = "liveGameCash";
  /**
   * live game coin
   */
  FLOW_TYPE["liveGameCoin"] = "liveGameCoin";
})(FLOW_TYPE || (FLOW_TYPE = {}));
export var getRecords = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params, options) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params.pcursor = params.pcursor || '';
            return _context.abrupt("return", axios.post('/rest/o/wallet-v2/main/flow', params, {
              silent: options === null || options === void 0 ? void 0 : options.silent
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getRecords(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();